module.exports = __webpack_public_path__ + "media/images/icon-addAdditionalFile-999120c0.png";